// FAQ (issue 34): a link to /pages/faq#switching opens that answer and scrolls to it.
function openFromHash() {
  const id = decodeURIComponent(location.hash.slice(1));
  const item = id ? document.getElementById(id) : null;
  if (item instanceof HTMLDetailsElement) {
    item.open = true;
    item.scrollIntoView({ block: "start" });
  }
}
window.addEventListener("hashchange", openFromHash);
openFromHash();
